var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 266,
    viewBox: "0 0 272 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdd_2_474)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2_474",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.701 119.5C233.701 164.291 197.391 200.6 152.6 200.6C107.81 200.6 71.5 164.291 71.5 119.5C71.5 74.7095 107.81 38.3997 152.6 38.3997C197.391 38.3997 233.701 74.7095 233.701 119.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.701 119.5C233.701 164.291 197.391 200.6 152.6 200.6C107.81 200.6 71.5 164.291 71.5 119.5C71.5 74.7095 107.81 38.3997 152.6 38.3997C197.391 38.3997 233.701 74.7095 233.701 119.5Z",
    fill: "url(#paint0_linear_2_474)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.701 119.5C231.701 163.186 196.286 198.6 152.6 198.6V202.6C198.495 202.6 235.701 165.395 235.701 119.5H231.701ZM152.6 198.6C108.914 198.6 73.5 163.186 73.5 119.5H69.5C69.5 165.395 106.705 202.6 152.6 202.6V198.6ZM73.5 119.5C73.5 75.8141 108.914 40.3997 152.6 40.3997V36.3997C106.705 36.3997 69.5 73.605 69.5 119.5H73.5ZM152.6 40.3997C196.286 40.3997 231.701 75.8141 231.701 119.5H235.701C235.701 73.605 198.495 36.3997 152.6 36.3997V40.3997Z",
    fill: "url(#paint1_linear_2_474)",
    mask: "url(#path-1-inside-1_2_474)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdd_2_474",
    x: 0.5,
    y: 0.399658,
    width: 271.201,
    height: 265.201,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2_474"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -21,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113438 0 0 0 0 0.148981 0 0 0 0 0.275 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_2_474",
    result: "effect2_dropShadow_2_474"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619608 0 0 0 0 0.423529 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2_474",
    result: "effect3_dropShadow_2_474"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2_474",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_474",
    x1: 148.918,
    y1: 39.8284,
    x2: 148.918,
    y2: 202.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DECFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E2FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_474",
    x1: 202.055,
    y1: -27.0053,
    x2: 164.11,
    y2: 165.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon1);
export default __webpack_public_path__ + "static/media/moon1.bafb058962b004ba5739d6c07aec4a06.svg";
export { ForwardRef as ReactComponent };